/**
 * BehaviorTracker - Registra eventos de comportamento do usuário
 * 
 * Usado pelo sistema de maturidade para calcular behavior_score
 * Integra com user_behavior_events
 */

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useBehaviorEvents } from '@/hooks/useBehaviorEvents';

export function BehaviorTracker() {
  const { user } = useAuth();
  const location = useLocation();
  const { logSessionStart, logPinOpen, logChatOpen } = useBehaviorEvents();
  
  // Controlar se já registrou sessão neste carregamento
  const sessionLoggedRef = useRef(false);

  // Registrar início de sessão uma vez por carregamento da app
  useEffect(() => {
    if (user && !sessionLoggedRef.current) {
      sessionLoggedRef.current = true;
      logSessionStart();
    }
  }, [user, logSessionStart]);

  // Registrar navegação para páginas específicas
  useEffect(() => {
    if (!user) return;

    const path = location.pathname;

    // PIN aberto
    if (path === '/meu-pin' || path.startsWith('/meu-pin/')) {
      logPinOpen();
    }

    // Chat aberto
    if (path === '/ia' || path.startsWith('/ia/')) {
      logChatOpen();
    }
  }, [user, location.pathname, logPinOpen, logChatOpen]);

  return null;
}

export default BehaviorTracker;
